import { provideZoneChangeDetection } from '@angular/core';

import { AppModule } from './app/app.module';

import { defineCustomElements } from '@siemens/ix-brand-theme/loader';
import { platformBrowser } from '@angular/platform-browser';

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err =>
    // eslint-disable-next-line no-console
    console.error(err)
  );

defineCustomElements();
